import { useSelector } from "react-redux";
import { AppState } from "../types";
import {
  ThemeOverrideWrapper,
  createProLogsTheme,
} from "../../components/layout/themes";
import { useContext } from "react";
import { PaletteType } from "@material-ui/core";
import { ThemeContext } from "../../components/layout/ThemeContext";

export const useProLogsTheme = (paletteType?: PaletteType) => {
  const brandTheme = useContext<ThemeOverrideWrapper>(ThemeContext);
  const type = useSelector((state: AppState) => state.theme);

  const loadFontFromTheme = (fontUrl: string) => {
    const link = document.createElement("link");
    link.href = fontUrl;
    link.rel = "stylesheet";
    document.head.appendChild(link);
  };

  const palette =
    (paletteType ?? type) === "dark"
      ? brandTheme.dark?.palette
      : brandTheme.light?.palette;

  const typography =
    (paletteType ?? type) === "dark"
      ? brandTheme.dark?.typography
      : brandTheme.light?.typography;

  const customPalette =
    (paletteType ?? type) === "dark"
      ? brandTheme.dark?.customPalette
      : brandTheme.light?.customPalette;

  const fontUrl =
    (paletteType ?? type) === "dark"
      ? brandTheme.dark?.fontUrl
      : brandTheme.light?.fontUrl;

  if(fontUrl) {
    loadFontFromTheme(fontUrl);
  }

  return createProLogsTheme(
    paletteType ?? type,
    palette ?? {},
    typography ?? {},
    customPalette
  );
};
